import { TomTable, useDefaultMRTOptions, useTomTable } from '@tom-ui/ui'
import { useTablePreferencesConfig } from '@tom-ui/utils'
import { MRT_ColumnDef, MRT_RowData } from 'material-react-table'
import { observer } from 'mobx-react-lite'

interface Props<T extends MRT_RowData> {
  items: T[]
  columns: MRT_ColumnDef<T>[]
  initialFilterStatus?: string[]
  renderRowActions?: (row: MRT_RowData) => React.ReactNode
  keepColumnFiltersState?: boolean
  keepPaginationState?: boolean
  keepColumnSortingState?: boolean
  tableName?: string
}

export const ReleaseTable = observer(<T extends MRT_RowData>(props: Props<T>) => {
  const {
    items,
    columns,
    initialFilterStatus,
    renderRowActions,
    keepColumnFiltersState,
    keepPaginationState,
    keepColumnSortingState,
    tableName,
  } = props
  const defaultOptions = useDefaultMRTOptions<T>()

  const { savedPreferences, onPreferencesChange } = useTablePreferencesConfig('planning/releases')

  const table = useTomTable<T>(
    {
      data: items,
      columns: columns,
      enableTopToolbar: false,
      enableRowSelection: false,
      enableExpanding: false,
      initialState: {
        ...defaultOptions.initialState,
        columnPinning: {
          left: ['mrt-row-actions', 'data.shippingLine', 'data.referenceNumber'],
        },
        columnFilters: [
          {
            id: 'status',
            value: initialFilterStatus,
          },
        ],
        pagination: {
          pageIndex: 0,
          pageSize: 50,
        },
      },
      muiTableContainerProps: {
        sx: {
          maxHeight: 'calc(100vh - 160px)',
          minHeight: 'calc(100vh - 160px)',
        },
      },
      renderRowActions,
    },
    undefined,
    undefined,
    { columns, savedPreferences, onPreferencesChange },
  )

  return (
    <TomTable
      table={table}
      keepPaginationState={keepPaginationState}
      keepColumnFiltersState={keepColumnFiltersState}
      keepColumnSortingState={keepColumnSortingState}
      tableName={tableName}
    />
  )
})
